import script from "./uploadMask.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadMask.vue?vue&type=script&setup=true&lang=js"

import "./uploadMask.vue?vue&type=style&index=0&id=51493230&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51493230"]])

export default __exports__